export const metricStatSchema = {
    type: 'object',
    title: 'MetricStat',
    required: [
        'metric',
        'stat'
    ],
    properties: {
        metric: {
            type: 'object',
            title: 'The metric schema',
            required: [
                'namespace',
                'metricName',
                'dimensions'
            ],
            properties: {
                namespace: {
                    type: 'string',
                    title: 'The namespace schema'
                },
                metricName: {
                    type: 'string',
                    title: 'The metricName schema'
                },
                dimensions: {
                    type: 'array',
                    title: 'The dimensions schema',
                    additionalItems: false,
                    maxItems: 10,
                    items: {
                        anyOf: [
                            {
                                type: 'object',
                                required: [
                                    'name',
                                    'value'
                                ],
                                properties: {
                                    name: {
                                        type: 'string',
                                        title: 'The dimensions name'
                                    },
                                    value: {
                                        type: 'string',
                                        title: 'The dimensions value'
                                    }
                                },
                                additionalProperties: false
                            }
                        ]
                    }
                }
            },
            additionalProperties: false
        },
        period: {
            type: 'integer',
            title: 'The period schema'
        },
        stat: {
            type: 'string',
            title: 'The stat schema'
        },
        unit: {
            type: 'string',
            title: 'The unit schema',
            enum: ['Seconds', 'Microseconds', 'Milliseconds', 'Bytes', 'Kilobytes', 'Megabytes',
            'Gigabytes', 'Terabytes', 'Bits', 'Kilobits', 'Megabits', 'Gigabits', 'Terabits',
            'Percent', 'Count', 'Bytes/Second', 'Kilobytes/Second', 'Megabytes/Second', 'Gigabytes/Second',
            'Terabytes/Second', 'Bits/Second', 'Kilobits/Second', 'Megabits/Second', 'Gigabits/Second',
            'Terabits/Second', 'Count/Second', 'None']
        }
    },
    additionalProperties: false
}
